module.exports = __webpack_public_path__ + "img/nr@3x.7f07d656.png";